import DashboardLayout from '../components/DashboardLayout';
import Breadcrumb from '../components/partials/Breadcrumb';
import PriceCard from '../components/partials/PriceCard';
import { checkoutUrl } from '../constants/externalLinks';

export default function TaxSupportPage() {
  return (
    <DashboardLayout>
      <div className="px-4 py-6 md:px-10 md:py-8" style={{ maxWidth: 960 }}>
        <Breadcrumb current="Crypto Tax Preparation" />

        {/* Hero */}
        <div className="dash-svc-hero">
          <div className="dash-svc-hero__inner">
            <p className="dash-svc-eyebrow">Crypto Tax Preparation</p>
            <h1 className="dash-svc-title font-serif">
              Crypto tax preparation that gets it right
            </h1>
            <div className="dash-svc-lede">
              <p>
                You swapped tokens on three different chains. You earned staking
                rewards on assets you bought at different prices. You minted an
                NFT, sold it eight months later, then used the proceeds to enter
                a liquidity pool. Your local CPA has no idea what any of that
                means &mdash; and honestly, why would they?
              </p>
              <p>
                Crypto tax reporting requirements have gotten specific. The IRS
                asks directly on Form 1040 whether you received, sold,
                exchanged, or disposed of digital assets. Checking
                &ldquo;no&rdquo; when the answer is &ldquo;yes&rdquo; creates
                problems down the road &mdash; and filing incorrect amounts
                creates different problems.
              </p>
              <p>
                DAG provides family office services for digital asset holders.
                We connect clients with tax professionals who prepare and file
                returns for people with crypto holdings alongside traditional
                investments. These aren&apos;t generalists learning on your
                dime.
              </p>
            </div>
          </div>
        </div>

        {/* Pricing */}
        <p className="dash-svc-section-label">Crypto tax services available</p>
        <div className="dash-price-grid">
          <PriceCard
            name="Individual Crypto Tax Preparation — Form 1040"
            sub="For individual filers with crypto activity"
            amount="$500"
            terms="Per filing"
            features={[
              'Digital asset reporting on Form 1040',
              'Capital gains & income from crypto',
              'Prepared and filed by tax professionals',
            ]}
            checkoutHref={checkoutUrl('crypto-tax-1040')}
            ctaGold
            featured
          />
          <PriceCard
            name="Sole Member LLC Tax Preparation — Form 1040 & Schedule C"
            sub="For single-member LLC owners"
            amount="$500"
            terms="Per filing"
            features={[
              'Form 1040 with Schedule C',
              'Pass-through entity reporting',
              'Crypto activity handled correctly',
            ]}
            checkoutHref={checkoutUrl('sole-member-llc-tax-1040')}
            ctaGold
            featured
          />
          <PriceCard
            name="Partnership Tax Preparation — Form 1065 & K-1"
            sub="For multi-member partnerships"
            amount="$500"
            terms="Per filing"
            features={[
              'Form 1065 partnership return',
              'Schedule K-1s for each partner',
              'Crypto gains allocated accurately',
            ]}
            checkoutHref={checkoutUrl('partnership-tax-1065')}
            ctaGold
            featured
          />
          <PriceCard
            name="Corporation Tax Preparation — Form 1120"
            sub="For C-corporations"
            amount="$500"
            terms="Per filing"
            features={[
              'Form 1120 corporate return',
              'Entity-level crypto reporting',
              'Filed by tax professionals',
            ]}
            checkoutHref={checkoutUrl('corporation-tax-1120')}
            ctaGold
            featured
          />
          <PriceCard
            name="Trust & Estate Tax Preparation — Form 1041"
            sub="Fiduciary income tax return"
            amount="$500"
            terms="Per filing"
            features={[
              'Form 1041 preparation',
              'Schedule K-1s for beneficiaries',
              'Crypto held in trust handled correctly',
            ]}
            checkoutHref={checkoutUrl('trust-estate-tax-1041')}
            ctaGold
            featured
          />
          <PriceCard
            name="Gift Tax Preparation — Form 709"
            sub="For reporting gifts of digital assets"
            amount="$500"
            terms="Per filing"
            features={[
              'Form 709 gift tax return',
              'Valuation of gifted crypto',
              'Prepared by tax professionals',
            ]}
            checkoutHref={checkoutUrl('gift-tax-709')}
            ctaGold
            featured
          />
        </div>
      </div>
    </DashboardLayout>
  );
}
